import React, { useState, useEffect, useMemo } from 'react'
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import ViaticosForm from './ViaticosForm'
import { toast } from 'react-toastify';
import Helpers from '../../Components/Helpers/Helpers';
import SweetAlert from '../../Components/SweetAlert/SweetAlert'
import ViaticosCheck from './ViaticosCheck';
import ViaticosReembolso from './ViaticosReembolso';

const Viaticos = ({ nameSingle, namePlural, separator }) => {
    const [isProcessing, setIsProccesing] = useState(true)
    const [modalShow, setModalShow] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [reload, setReload] = useState(true);
    const [rows, setRows] = useState([])
    const [loadSubmit, setLoadSubmit] = useState(false)
    const [dataUpdated, setDataUpdated] = useState({})
    const [showConfirmDelete, setShowConfirmDelete] = useState(false)
    const [loadSubmitDelete, setLoadSubmitDelete] = useState(false)
    const [dataDeleted, setDataDeleted] = useState({})
    const [alertShow, setAlertShow] = useState(false)
    const [alertProps, setAlertProps] = useState({})
    const [alertLoad, setAlertLoad] = useState(false)
    const [typeForm, setTypeForm] = useState(null)

    const [dataFiles, setDataFiles] = useState({})
    const [report, setReport] = useState({})

    useEffect(() => {
        if (reload) {
            setIsProccesing(true)
            Controllers.viaticos.get_viaticos_doc_user().then(res => {
                setRows(res.data.rows)
                setReport({
                    excel: res.data.excel.file,
                    filename: res.data.excel.filename,
                })
            }).catch(req => Helpers.promise.catch({ req, toast }))
                .finally(() => {
                    setIsProccesing(false)
                    setReload(false)
                })
        }
    }, [reload])

    const handleInsertUpdate = ({ data }) => {
        setLoadSubmit(true)
        Controllers.viaticos.viaticos_doc_insert_update(data).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setModalShow(false)
                setDataUpdated({})
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setLoadSubmit(false)
                setReload(true)
            })
    }

    const handleFilesInsertUpdate = ({ data }) => {
        setLoadSubmit(true)
        Controllers.viaticos.viaticos_doc_comprobar(data).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setModalShow(false)
                setDataFiles({})
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setLoadSubmit(false)
                setReload(true)
            })
    }

    const handleImageInsertUpdate = ({ data }) => {
        setLoadSubmit(true)
        Controllers.viaticos.viaticos_doc_reembolso(data).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setModalShow(false)
                setDataFiles({})
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setLoadSubmit(false)
                setReload(true)
            })
    }

    const handleGet = e => {
        setTypeForm(1)
        let $this = e.currentTarget

        if (!$this.dataset?.idViaticosDoc) {
            setModalTitle(`Registrar ${nameSingle}`)
            setDataUpdated({})
            setModalShow(true);
            return
        }

        let { idViaticosDoc, disabled = 0 } = $this.dataset

        setModalTitle(`Modificar ${nameSingle} #${idViaticosDoc}`)
        setDataUpdated({
            data: {
                id_viaticos_doc: idViaticosDoc
            },
            disabled: parseInt(disabled) === 1 ? 1 : 0
        })
        setModalShow(true);
    }

    const handleDelete = () => {
        setLoadSubmitDelete(true)

        Controllers.viaticos.viaticos_doc_delete(dataDeleted).then(res => {
            Helpers.toast.construct({ ...res, toast })
            if (res.response === 'success') {
                setShowConfirmDelete(false)
                setDataDeleted({})
            }
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setReload(true)
                setLoadSubmitDelete(false)
            })
    }

    const handleHideModalForm = () => {
        setModalShow(false)
        setLoadSubmit(false)
    }

    const handleShowModalDelete = e => {
        let { idViaticosDoc } = e.currentTarget.dataset
        setDataDeleted({
            p_id_viaticos_doc: idViaticosDoc,
        })
        setShowConfirmDelete(true)
    }

    const handleHideModalDelete = () => setShowConfirmDelete(false)

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                { name: 'id_viaticos_doc', text: 'ID', align: 'center' },
                { name: 'full_name', text: 'Trabajador', align: 'center' },
                { name: 'date_start_viaticos_doc', text: 'Fecha Inicio', align: 'center' },
                { name: 'date_end_viaticos_doc', text: 'Fecha Fin', align: 'center' },
                { name: 'total_viaticos_doc', text: 'Total', align: 'center' },
                {
                    name: 'total_comprobado', text: 'Reembolso', align: 'left', render: u => {
                        if (parseInt(u.status_viaticos_doc) !== 4) {
                            return <></>
                        }

                        return <>
                            <div className='mb-2'>
                                <span>{u.total_comprobado}</span>
                            </div>
                            {u.image_reembolso && <div>
                                <a href={Helpers.config.resourcesUrl({
                                    url: u.image_reembolso
                                })}>
                                    <i className="fa fa-download"></i>
                                </a>
                            </div>}
                        </>
                    }
                },
                {
                    name: 'total_resto', text: 'Comprobación', align: 'left', render: u => {
                        if (parseInt(u.status_viaticos_doc) !== 4) {
                            return <></>
                        }

                        return <>
                            <div>
                                <strong>Resto: </strong>
                                <span>{u.resto_comprobado}</span>
                            </div>
                            <div>
                                <a href={Helpers.config.resourcesUrl({
                                    url: u.file_zip
                                })}>
                                    <i className="fa fa-download"></i>
                                </a>
                            </div>
                        </>
                    }
                },
                {
                    name: 'file_zip', text: 'Descargar', align: 'center', render: r => {
                        if (!r.file_zip) return <></>

                        return <a href={Helpers.config.resourcesUrl({
                            url: r.file_zip
                        })}>
                            <i className="fa fa-download"></i>
                        </a>
                    }
                },
                {
                    name: 'status_viaticos_doc', text: 'Estado', align: 'center', render: r => {
                        let statusText = ''
                        let color = ''
                        switch (r.status_viaticos_doc) {
                            case 0:
                                statusText = 'Pendiente'
                                color = 'info'
                                break;
                            case 1:
                                statusText = 'Enviado'
                                color = 'primary'
                                break;
                            case 2:
                                statusText = 'Aprobado'
                                color = 'success'
                                break;
                            case 3:
                                statusText = 'Rechazado'
                                color = 'danger'
                                break;
                            case 4:
                                statusText = 'Comprobado'
                                color = 'primary'
                                break;
                            default:
                                statusText = ''
                                color = ''
                                break;
                        }

                        return <div className={'badge badge-' + color}>
                            {statusText}
                        </div>
                    }
                },
                {
                    name: 'actions', text: <i className="fa fa-cog"></i>, align: 'center', render: u => {
                        return <div>
                            {parseInt(u.status_viaticos_doc) !== 0 && parseInt(u.status_viaticos_doc) !== 3 && <Button variant="info" className="mr-1" size="xs" data-id-viaticos-doc={u.id_viaticos_doc} onClick={handleGet} data-disabled="1">
                                <i className="fa fa-eye"></i>
                            </Button>}
                            {(parseInt(u.status_viaticos_doc) === 0 || parseInt(u.status_viaticos_doc) === 3) && <Button variant="info" className="mr-1" size="xs" data-id-viaticos-doc={u.id_viaticos_doc} onClick={handleGet}>
                                <i className="fa fa-edit"></i>
                            </Button>}
                            {(parseInt(u.status_viaticos_doc) === 0 || parseInt(u.status_viaticos_doc) === 3) && <Button variant="danger mr-1" size="xs" data-id-viaticos-doc={u.id_viaticos_doc} data-name-viaticos={u.name_viaticos} onClick={handleShowModalDelete}>
                                <i className="fa fa-trash"></i>
                            </Button>}
                            {(parseInt(u.status_viaticos_doc) === 0 || parseInt(u.status_viaticos_doc) === 3) && <Button variant="success" className="mr-1" size="xs" data-id-viaticos-doc={u.id_viaticos_doc} onClick={e => {
                                setAlertProps({
                                    icon: 'approve',
                                    title: <>¿Desea enviar {separator} {nameSingle}?</>,
                                    subtitle: <>#{u.id_viaticos_doc}</>,
                                    confirmButtonText: '¡Sí, enviar!',
                                    cancelButtonText: '¡No!',
                                    loadSubmit: alertLoad,
                                    onConfirm: _ => {
                                        setAlertLoad(true)

                                        Controllers.viaticos.viaticos_doc_sent({
                                            p_id_viaticos_doc: u.id_viaticos_doc
                                        }).then(res => {
                                            Helpers.toast.construct({ ...res, toast })
                                            if (res.response === 'success') {
                                                setAlertShow(false)
                                            }
                                        }).catch(req => Helpers.promise.catch({ req, toast }))
                                            .finally(() => {
                                                setReload(true)
                                                setAlertLoad(false)
                                            })
                                    },
                                })
                                setAlertShow(true)
                            }}>
                                <i className="fas fa-paper-plane"></i>
                            </Button>}
                            {parseInt(u.status_viaticos_doc) === 2 && <Button variant="dark" className="mr-1" size="xs" data-id-viaticos-doc={u.id_viaticos_doc} onClick={e => {
                                setTypeForm(2)
                                let $this = e.currentTarget

                                let { idViaticosDoc } = $this.dataset

                                setModalTitle(`Comprobación ${nameSingle} #${idViaticosDoc}`)
                                setDataFiles({
                                    id_viaticos_doc: idViaticosDoc,
                                    total: u.total_viaticos_doc
                                })
                                setModalShow(true);
                            }}>
                                <i className="far fa-folder-open"></i>
                            </Button>}
                            {parseInt(u.status_viaticos_doc) === 4 && !u.image_reembolso && parseFloat(u.resto_comprobado) > 0 && <Button variant="dark" className="mr-1" size="xs" data-id-viaticos-doc={u.id_viaticos_doc} onClick={e => {
                                setTypeForm(3)
                                let $this = e.currentTarget

                                let { idViaticosDoc } = $this.dataset

                                setModalTitle(`Reembolso ${nameSingle} #${idViaticosDoc}`)
                                setDataFiles({
                                    id_viaticos_doc: idViaticosDoc,
                                })
                                setModalShow(true);
                            }}>
                                <i className="fa fa-image"></i>
                            </Button>}
                        </div>
                    }
                },
            ],
        ]}
        rows={rows}
        isProcessing={isProcessing}
    />, [rows, isProcessing])

    return <>
        <Card>
            <Card.Header className="justify-content-between">
                <span>Listado De {namePlural}</span>
                <Button size="sm" onClick={handleGet}>
                    <i className="fa fa-plus mr-1"></i> Registrar {nameSingle}
                </Button>
            </Card.Header>
            <Card.Body>
                {report?.filename ? <div className='mb-4'>
                    <a href={report?.excel} download={report?.filename} className="mr-2">
                        <Button size="sm" variant="success">
                            <i className="fa fa-file-excel mr-2"></i>Descargar Reporte Excel
                        </Button>
                    </a>
                </div> : ''}
                {dtRows}
            </Card.Body>
        </Card>
        <Modal show={modalShow} onHide={handleHideModalForm} backdrop="static" size='xl'>
            <Modal.Header closeButton>
                <Modal.Title as="div">{modalTitle}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {typeForm === 1 && <ViaticosForm onSubmit={handleInsertUpdate} loadSubmit={loadSubmit} {...dataUpdated} />}
                {typeForm === 2 && <ViaticosCheck onSubmit={handleFilesInsertUpdate} loadSubmit={loadSubmit} {...dataFiles} />}
                {typeForm === 3 && <ViaticosReembolso onSubmit={handleImageInsertUpdate} loadSubmit={loadSubmit} {...dataFiles} />}
            </Modal.Body>
        </Modal>
        <SweetAlert
            icon="delete"
            show={showConfirmDelete}
            showCancelButton
            title={<>¿Desea eliminar {separator} {nameSingle}?</>}
            subtitle={<>#{dataDeleted.p_id_viaticos_doc}</>}
            confirmButtonText="¡Sí, eliminar!"
            cancelButtonText="¡No!"
            loadSubmit={loadSubmitDelete}
            onCancel={handleHideModalDelete}
            onConfirm={handleDelete}
        />
        <SweetAlert
            icon="delete"
            show={alertShow}
            {...alertProps}
            onCancel={_ => setAlertShow(false)}
        />
    </>
}

export default Viaticos